import { Box, Typography } from '@mui/material';
import theme from '../../../theme';

const SearchResultHeader = ({ query }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'flex-end',
        gap: 1,
        mb: { xs: 3, md: 3.75, lg: 6.25 },
      }}
    >
      <Typography fontSize={{ xs: 12, md: 14 }} color={theme.palette.black[4]}>
        다음에 대한 검색 결과
      </Typography>
      <Typography
        fontSize={{ xs: 14, md: 18, lg: 20 }}
        fontWeight={700}
        color={theme.palette.secondary.main}
      >
        '{query}'
      </Typography>
    </Box>
  );
};

export default SearchResultHeader;
